// Mock data for SpaceGems Bauxite Trading website

export const services = [
  {
    id: 1,
    title: "Bauxite Trading & Brokerage",
    description: "Direct sourcing of premium-grade bauxite from Guinea with reliable supply chains to Asia, Middle East, and Europe.",
    icon: "TrendingUp",
    features: ["Quality assurance", "Competitive pricing", "Flexible terms", "Global logistics"]
  },
  {
    id: 2,
    title: "Supply Chain Management",
    description: "End-to-end logistics coordination from mine to port, ensuring timely delivery and quality maintenance.",
    icon: "Ship",
    features: ["Port handling", "Documentation", "Customs clearance", "Tracking systems"]
  },
  {
    id: 3,
    title: "Quality Consulting",
    description: "Expert analysis and consulting on bauxite quality, specifications, and market conditions.",
    icon: "Award",
    features: ["Lab testing", "Grade analysis", "Market reports", "Technical advisory"]
  }
];

export const regions = [
  {
    id: 1,
    name: "Guinea",
    role: "Source",
    description: "Premium bauxite reserves with established mining partnerships",
    icon: "MapPin"
  },
  {
    id: 2,
    name: "Asia",
    role: "Primary Market",
    description: "Major aluminum producers in China, India, and Southeast Asia",
    icon: "Globe"
  },
  {
    id: 3,
    name: "Middle East",
    role: "Growing Market",
    description: "Expanding aluminum smelting capacity in UAE and Saudi Arabia",
    icon: "Building2"
  },
  {
    id: 4,
    name: "Europe",
    role: "Strategic Market",
    description: "Established aluminum industry with quality requirements",
    icon: "Landmark"
  }
];

export const insights = [
  {
    id: 1,
    title: "Guinea Bauxite Production Outlook 2025",
    category: "Market Analysis",
    date: "2025-03-15",
    excerpt: "Analysis of Guinea's bauxite production capacity and export trends for Asian markets.",
    readTime: "8 min read"
  },
  {
    id: 2,
    title: "Asia-Pacific Aluminum Demand Trends",
    category: "Industry Report",
    date: "2025-03-10",
    excerpt: "Growing aluminum production capacity drives increased bauxite imports across Asia.",
    readTime: "6 min read"
  },
  {
    id: 3,
    title: "Bauxite Quality Specifications Guide",
    category: "Technical Resource",
    date: "2025-03-05",
    excerpt: "Comprehensive guide to bauxite grades, chemical composition, and quality standards.",
    readTime: "12 min read"
  },
  {
    id: 4,
    title: "Middle East Smelting Expansion Impact",
    category: "Market Analysis",
    date: "2025-02-28",
    excerpt: "How new aluminum smelters in UAE and Saudi Arabia are reshaping bauxite trade routes.",
    readTime: "7 min read"
  }
];

export const resources = [
  {
    id: 1,
    title: "Bauxite Trading Guide 2025",
    type: "PDF",
    size: "2.4 MB",
    description: "Complete guide to international bauxite trading practices and regulations."
  },
  {
    id: 2,
    title: "Quality Specifications Sheet",
    type: "PDF",
    size: "850 KB",
    description: "Detailed chemical and physical specifications for Guinea bauxite grades."
  },
  {
    id: 3,
    title: "Company Profile & Capabilities",
    type: "PDF",
    size: "1.8 MB",
    description: "SpaceGems corporate profile, partnerships, and service capabilities."
  }
];

export const stats = [
  {
    value: "900K+",
    label: "Tons Traded Annually"
  },
  {
    value: "15+",
    label: "Countries Served"
  },
  {
    value: "98%",
    label: "On-Time Delivery"
  },
  {
    value: "24/7",
    label: "Global Support"
  }
];

export const testimonials = [
  {
    id: 1,
    company: "Asian Aluminum Corp",
    location: "China",
    text: "SpaceGems has been our reliable bauxite supplier for 3 years. Consistent quality and timely deliveries.",
    rating: 5
  },
  {
    id: 2,
    company: "Middle East Smelters",
    location: "UAE",
    text: "Professional service and competitive pricing. Their supply chain management is exceptional.",
    rating: 5
  }
];